import { useEffect, useState } from "react";
import axios from "axios";
import { Trophy, Flame, UtensilsCrossed, Star, TrendingDown } from "lucide-react";
import { API, money, errorMessage } from "../api";
import { ddmmyyyy } from "./Digest";
import { WeekCompare } from "./Weekly";
import "./digest.css";

const hourLabel = (h) => `${((h + 11) % 12) + 1} ${h < 12 ? "AM" : "PM"}`;

export default function PublicWeekly({ reportId }) {
  const [r, setR] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { axios.get(`${API}/public/weekly/${reportId}`).then((x) => setR(x.data)).catch((e) => setErr(errorMessage(e))); }, [reportId]);
  if (err) return <div className="pd-shell"><div className="pd-card" data-testid="public-weekly-error">{err}</div></div>;
  if (!r) return <div className="pd-shell"><div className="pd-card">Loading…</div></div>;
  const m = r.metrics;
  const day = (x) => (x ? `${x.weekday} ${ddmmyyyy(x.date)}` : "—");
  return (
    <div className="pd-shell" data-testid="public-weekly-page">
      <div className="pd-card">
        <span className="pd-over">FYNDINE · WEEKLY OWNER REPORT</span>
        <h1 data-testid="public-weekly-branch">{r.branch_name}</h1>
        <p>{r.branch_city ? `${r.branch_city} · ` : ""}{ddmmyyyy(r.week_start)} → {ddmmyyyy(r.week_end)} vs previous week</p>
        <WeekCompare r={r} />
        <div className="pd-grid" style={{ marginTop: 14 }}>
          <div className="pd-stat" data-testid="public-weekly-best"><Star size={16} /><span>Best day</span><b>{day(m.best_day)}</b><small>{m.best_day ? money(m.best_day.sales) : ""}</small></div>
          <div className="pd-stat" data-testid="public-weekly-worst"><TrendingDown size={16} /><span>Worst day</span><b>{day(m.worst_day)}</b><small>{m.worst_day ? money(m.worst_day.sales) : ""}</small></div>
          <div className="pd-stat"><Trophy size={16} /><span>Top waiter</span><b>{m.top_waiter?.name || "—"}</b><small>{m.top_waiter ? money(m.top_waiter.sales) : ""}</small></div>
          <div className="pd-stat"><UtensilsCrossed size={16} /><span>Best-seller</span><b>{m.best_seller?.name || "—"}</b><small>{m.best_seller ? `${m.best_seller.qty} sold` : ""}</small></div>
          <div className="pd-stat"><Flame size={16} /><span>Peak hour</span><b>{m.peak_hour ? hourLabel(m.peak_hour.hour) : "—"}</b><small>{m.peak_hour ? money(m.peak_hour.sales) : ""}</small></div>
        </div>
        {m.top_items?.length > 0 && <><h3>Top items</h3>{m.top_items.map((i) => <div className="pd-row" key={i.name}><span>{i.name}</span><em>{i.qty} sold</em><b>{money(i.revenue)}</b></div>)}</>}
        <footer>Generated by FynDine · VSM Transnational Pvt Ltd</footer>
      </div>
    </div>
  );
}
